var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"body"}},[_c('top-navbar'),_c('article',{staticClass:"master-wrapper"},[_c('hero-image'),_c('section',{staticClass:"master-section container"},[_c('div',{staticClass:"row no-gutters"},[_c('main-content')],1)]),_c('sponsors'),_c('associated-sites')],1),_c('content-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }